export const obtenerPorcentajeTodasCalificaciones = (arrCalificaciones=[]) => {


    if (arrCalificaciones.length === 0){
        return 0
    }

    let numRespuestas = 0
    let numPuntos = 0
    for (let i = 0; i < arrCalificaciones.length; i++) {
        let calificacion = arrCalificaciones[i]
        let respuestas = calificacion.calificaciones

        for (let j = 0; j < respuestas.length;  j++) {
            numRespuestas++
            if (respuestas[j].punto){
                numPuntos++
            }
        }


    }

    //Sacamos promedio

    let prom = (numPuntos * 100) / numRespuestas

    return prom.toFixed(2)


}